// removed by extract-text-webpack-plugin
module.exports = {"screenshotContainer":"_1H9g","screenshot":"_1bgJ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/CaseStudies/MiasanoCaseStudy/Screenshot/styles.scss
// module id = 544
// module chunks = 0